/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { TwilioPreview } from 'cio/utils/previews';
import { phone } from 'phone';

const SMS_SPLIT_LENGTH = 160;
const MMS_SPLIT_LENGTH = 1600;

interface PreviewerArgs {
  preview: TwilioPreview;
}

export default class Previewer extends Component<PreviewerArgs> {
  get smsSplitLength() {
    return this.args.preview?.image_url ? MMS_SPLIT_LENGTH : SMS_SPLIT_LENGTH;
  }

  get isRecipientUSOrCanada() {
    let to = this.args.preview?.to;
    let phoneMeta = phone(to);
    return phoneMeta.isValid && (phoneMeta.countryIso2 === 'US' || phoneMeta.countryIso2 === 'CA');
  }
}
